import { el } from './dom.js';

export type BreadcrumbItem = { label: string; href?: string };

export type PageHeaderOptions = {
  title: string;
  subtitle?: string;
  breadcrumbs?: BreadcrumbItem[];
  actions?: HTMLElement;
};

export function createBreadcrumb(items: BreadcrumbItem[]): HTMLElement {
  const nav = el('nav', { 'aria-label': "Fil d'Ariane" });
  const list = el('ol', { class: 'breadcrumb' });
  items.forEach((item) => {
    const li = el('li');
    if (item.href) {
      const a = el('a', { href: item.href, text: item.label });
      a.addEventListener('click', (e) => {
        e.preventDefault();
        const href = item.href!;
        window.location.hash = href.startsWith('#') ? href.slice(1) : href;
      });
      li.appendChild(a);
    } else {
      li.textContent = item.label;
    }
    list.appendChild(li);
  });
  nav.appendChild(list);
  return nav;
}

export function createPageHeader(options: PageHeaderOptions): HTMLElement {
  const header = el('header', { class: 'page-header' });
  if (options.breadcrumbs?.length) {
    header.appendChild(createBreadcrumb(options.breadcrumbs));
  }
  const row = el('div', { class: 'page-header-row' });
  const titles = el('div');
  titles.appendChild(el('h1', { class: 'page-title', text: options.title }));
  if (options.subtitle) {
    titles.appendChild(el('p', { class: 'page-subtitle', text: options.subtitle }));
  }
  row.appendChild(titles);
  if (options.actions) {
    const actions = el('div', { class: 'page-actions' });
    actions.appendChild(options.actions);
    row.appendChild(actions);
  }
  header.appendChild(row);
  return header;
}

export function createPageShell(options: PageHeaderOptions & { wide?: boolean }): {
  page: HTMLElement;
  header: HTMLElement;
  body: HTMLElement;
} {
  const page = el('div', { class: `page${options.wide ? ' page--wide' : ''}` });
  const header = createPageHeader(options);
  const body = el('div', { class: 'page-body' });
  page.appendChild(header);
  page.appendChild(body);
  return { page, header, body };
}

export function mountHubPage(
  root: HTMLElement,
  options: {
    title: string;
    subtitle: string;
    cards: { title: string; description: string; href: string; icon?: string }[];
  }
): void {
  root.innerHTML = '';
  root.className = 'app-view circuits-app';
  const { page, body } = createPageShell({
    title: options.title,
    subtitle: options.subtitle,
  });
  const grid = el('div', { class: 'hub-grid' });
  options.cards.forEach((card) => {
    const wrap = el('div', { class: 'card-glow-wrap' });
    const a = el('a', { class: 'card-glow', href: card.href });
    a.appendChild(el('p', { class: 'heading', text: card.title }));
    a.appendChild(el('p', { text: card.description }));
    a.appendChild(el('p', { text: 'Ouvrir →' }));
    a.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.hash = card.href.replace(/^#/, '');
    });
    wrap.appendChild(a);
    grid.appendChild(wrap);
  });
  body.appendChild(grid);
  root.appendChild(page);
}
